import React, { useState, useEffect } from 'react';
import './Headlines.css';
import ApiService from '../../../services/apiService'; // keep this if you use a central service

const Headlines = () => {
  const [isPaused, setIsPaused] = useState(false);
  const [headlines, setHeadlines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Dummy data for fallback
  const dummyHeadlines = [
    {
      id: 'dummy-1',
      text: 'Admission Process for Academic Year 2024-25 Now Open',
      date: '2024-10-15',
      isNew: true,
      link: '#'
    },
    {
      id: 'dummy-2',
      text: 'University Achieves NAAC A+ Grade Accreditation',
      date: '2024-10-10',
      isNew: true,
      link: '#'
    },
    {
      id: 'dummy-3',
      text: 'Research Symposium on Sustainable Development Scheduled',
      date: '2024-10-05',
      isNew: false,
      link: '#'
    }
  ];

  useEffect(() => {
    fetchHeadlines();
  }, []);

  const fetchHeadlines = async () => {
    try {
      setLoading(true);

      const response = await ApiService.getHeadlines();
      const data = response.data;

      // === Option 2: Direct API call
      // const res = await fetch('http://ru-wordpress-local.local/wp-json/wp/v2/headlines');
      // const data = await res.json();

      // Map and normalize API response to your frontend structure
      const formatted = data.map((item) => ({
        id: item.id,
        text: item.title.rendered,
        date: item.date,
        isNew: item.acf?.is_new || false,
        link:
          item.acf?.document_link ||
          item.acf?.file_upload?.url ||
          item.link ||
          '#',
        image: item.acf?.file_upload?.url || null
      }));

      setHeadlines(formatted);
      setError(null);
    } catch (err) {
      console.error('Error fetching headlines:', err);
      setError('Failed to load headlines');
      setHeadlines(dummyHeadlines); // fallback
    } finally {
      setLoading(false);
    }
  };

  const handleItemClick = (link) => {
    if (!link || error) return;

    if (link.startsWith('http://') || link.startsWith('https://')) {
      window.open(link, '_blank', 'noopener,noreferrer');
    } else if (link.startsWith('/')) {
      console.log('Navigate to:', link);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short'
    });
  };

  const displayData = headlines.length > 0 ? headlines : dummyHeadlines;

  return (
    <div className="headlines-container">
      <div className="headlines-wrapper">
        <div className="headlines-label">Headlines</div>

        <div
          className="headlines-display"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className={`headlines-scroll ${isPaused ? 'paused' : ''}`}>
            {loading ? (
              <div className="headline-item" style={{ opacity: 0.7, fontStyle: 'italic' }}>
                Loading headlines...
              </div>
            ) : (
              <>
                {displayData.map((headline) => (
                  <div
                    key={headline.id}
                    className="headline-item"
                    onClick={() => handleItemClick(headline.link)}
                    style={{ cursor: (error || !headline.link) ? 'default' : 'pointer' }}
                  >
                    {headline.isNew && <span className="new-flag">NEW</span>}
                    <span className="headline-date">{formatDate(headline.date)}</span>
                    <span className="headline-text">{headline.text}</span>
                    <span className="headline-separator">•</span>
                  </div>
                ))}

                {/* Duplicate for seamless scroll */}
                {displayData.map((headline) => (
                  <div
                    key={`dup-${headline.id}`}
                    className="headline-item"
                    onClick={() => handleItemClick(headline.link)}
                    style={{ cursor: (error || !headline.link) ? 'default' : 'pointer' }}
                  >
                    {headline.isNew && <span className="new-flag">NEW</span>}
                    <span className="headline-date">{formatDate(headline.date)}</span>
                    <span className="headline-text">{headline.text}</span>
                    <span className="headline-separator">•</span>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Headlines;
